<template>
  <div class="home ma-2">
    <!-- {{ currentRouteName }} -->
    <v-fade-transition>
      <div v-if="lensId">
        <soft-details @close="lensId = null"></soft-details>
      </div>
      <div v-else-if="currentRouteName == 'clCompanies'">
        <select-company></select-company>
      </div>
      <div v-else-if="currentRouteName == 'hybrids'">
        <hybrids></hybrids>
      </div>
      <div v-else-if="currentRouteName == 'clsByRx' && activeSubscription">
        <soft-power-result-table></soft-power-result-table>
      </div>
      <div v-else-if="currentRouteName == 'clsByRx' && !activeSubscription">
        <div class="ma-4 text-center">
          <div class="text-h4">
            Sorry, searching by refraction is an
            <b>EyeDock <span style="color: orange">Pro</span></b>
            feature.
          </div>

          <div class="my-4">Register (or log in) to enjoy this feature.</div>
          <user-login :textButton="false"></user-login>
        </div>
      </div>
      <div v-else-if="currentRouteName == 'advanced'">
        <cl-advanced-search></cl-advanced-search>
      </div>
      <div v-else-if="hasTypeOrCompanyOrTerm">
        <soft-home @isPowerSearch="isPowerSearch = $event" />
      </div>
      <div v-else>
        <popular-lenses></popular-lenses>
      </div>
    </v-fade-transition>
  </div>
</template>

<script>
import StyleUtilities from "@/assets/js/StyleUtilities";
import UserMixin from "@/assets/js/UserMixin";

export default {
  name: "lenses",
  mixins: [StyleUtilities, UserMixin],
  components: {
    // FilterSummary: () => import("@/components/clStuff/FilterSummary.vue"),
    SoftHome: () => import("@/components/clStuff/SoftHome"),
    ClAdvancedSearch: () => import("@/components/clStuff/ClAdvancedSearch"),
    SoftDetails: () => import("@/components/clStuff/SoftDetails"),
    SelectCompany: () => import("@/components/clStuff/SelectCompany"),
    SoftPowerResultTable: () =>
      import("@/components/clStuff/SoftPowerResultTable"),
    UserLogin: () => import("@/components/universalStuff/UserLogin"),
    PopularLenses: () => import("@/components/clStuff/PopularLenses"),
    Hybrids: () => import("@/components/clStuff/Hybrids"),
  },
  data: () => ({
    hideDiscontinued: true,
    isPowerSearch: false,
    lensId: null, // can be a numeric id or a slug (eg "acuvue_oasys")
    // lensType: "any",
    hasTypeOrCompanyOrTerm: null,
  }),
  computed: {
    // ...mapState(["rx"]),
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    // doSearch() {
    //   console.log("doSearch");
    // },
  },

  mounted() {
    if (this.$route.params.type) this.hasTypeOrCompanyOrTerm = true;
    if (this.$route.params.company) this.hasTypeOrCompanyOrTerm = true;
    if (this.$route.params.term) this.hasTypeOrCompanyOrTerm = true;
    if (this.$route.query.term) this.hasTypeOrCompanyOrTerm = true;
    if (this.$route.query.q) this.hasTypeOrCompanyOrTerm = true;
    if (this.$route.params.lensSlug) {
      // this.lensId = this.$route.params.id;
      this.lensId = this.$route.params.lensSlug;
    }
  },
  created() {
    if (!this.$store.state.clCompanies) this.$store.dispatch("loadCompanies");
  },
};
</script>

<style scoped>
/* .filterInputDiv {
  max-width: 200px;
} */
</style>
